module.exports = __webpack_public_path__ + "static/media/34-1.90abc9ee.mp3";